import {MatchState} from './interfaces';
import {addBrowserSideAppHeaders} from '@/utils/unityHeaders';
import {getUserId} from '@/services/internal/user/getUserId';
import {USER_ID_HEADER} from '@/utils/constant';

interface Params {
  data: string;
  state: MatchState;
  isCash: boolean;
  gameId: string;
  token: string;
}

export default async function submitScore({data, state, isCash, gameId, token}: Params) {
  const headers = {};
  await addBrowserSideAppHeaders(headers);
  headers['User-Agent'] = navigator.userAgent;
  headers[USER_ID_HEADER] = getUserId();
  try {
    await fetch('/api/report-score', {
      method: 'PATCH',
      body: JSON.stringify({
        data,
        state,
        isCash,
        gameId,
        token,
      }),
      headers: headers,
    });
  } catch (e) {
    console.log('failed to report score', e, 'for match data:', data);
    throw e;
  }
}
